import './icon.css'

export const LinearScale = ({ style, classToUse }) => {
  const getStyle = () => {
    if (classToUse && classToUse >= 1) {
      return `linea scale${classToUse}`
    }
    return 'linea'
  }
  return (
    <div className={getStyle()} style={style}>
      {classToUse && classToUse > 2 ? <div className='circulo-centro' /> : undefined}
    </div>
  )
}

export const VerticalScale = ({ style }) => {
  return <div className={'lineaVertical'} style={style}></div>
}
